import { isValidMonth, toDate } from './utils';

const monthNamesShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export default function MonthPicker({
  value,
  onChange,
  year,
  minDate,
  maxDate,
}: {
  value?: Date;
  maxDate?: Date;
  minDate?: Date;
  year: number;
  onChange: (date: Date) => void;
}) {
  return (
    <div className="grid grid-cols-6 h-full justify-content-center text-xs">
      {monthNamesShort.map((month, monthIndex) => (
        <MonthButton
          key={month}
          month={month}
          isValid={isValidMonth(year, monthIndex + 1, minDate, maxDate)}
          onClick={() => onChange(toDate(1, monthIndex + 1, year))}
        />
      ))}
    </div>
  );
}

function MonthButton({
  month,
  onClick,
  isValid,
}: {
  month: string;
  isValid?: boolean;
  onClick: () => void;
}) {
  return (
    <div
      className={`${
        isValid
          ? 'cursor-pointer hover:text-white  hover:bg-green'
          : 'bg-gray-lighter bg-opacity-10 text-gray-700'
      } rounded py-1 flex font-semibold justify-center items-center  border-white border `}
      onClick={(_) => isValid && onClick()}
    >
      {month}
    </div>
  );
}
